import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FsLvtLights extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public state: string;

  @Expose()
  public name: string;

  @Expose()
  public type: string;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
